module.exports = __webpack_public_path__ + "media/images/thumbs/biology/q_quiz_plant_cell_2-57e5be36475594d75ba31fa09ed87879.jpg";